(function() {
    'use strict';

    angular.module('components.directives', [
        'components.draggable',
        'components.window'
    ]);

})();
